/****************
 * Clerk client configuration
 * Replaces Supabase authentication
 ****************/

export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '';

if (!CLERK_PUBLISHABLE_KEY) {
  console.warn(
    'Missing VITE_CLERK_PUBLISHABLE_KEY environment variable. ' +
    'Authentication will not work properly.'
  );
}
